import { mooberApiV2 as apiV2 } from '@/api/mooberApi';

const initiate = ({ companyId }) => apiV2.get(`/company/${companyId}/qb/connect`);
const saveAuthentication = ({ code, companyId, realmId }) => apiV2.post(`/company/${companyId}/qb/connect`, { code, realmId });
const revokeAuthentication = ({ companyId }) => apiV2.delete(`/company/${companyId}/qb/connect`);
const refreshQuickbooksAccount = (companyId) => apiV2.post(`/company/${companyId}/qb/refresh`);
const getCustomers = companyId => apiV2.get(`/company/${companyId}/qb/customers`);
const getVendors = companyId => apiV2.get(`/company/${companyId}/qb/vendors`);
const getAccounts = companyId => apiV2.get(`/company/${companyId}/qb/accounts`);
const getSalesTerms = companyId => apiV2.get(`/company/${companyId}/qb/salesTerms`);
const getSalesItems = companyId => apiV2.get(`/company/${companyId}/qb/salesItems`);
const getTaxCodes = companyId => apiV2.get(`/company/${companyId}/qb/taxCodes`);
const saveExportDefaults = (companyId, body) => apiV2.post(`company/${companyId}/qb/exportDefaults`, body);

const updateVendorDispatcher = (companyId, vendorId, body) => apiV2.post(`/company/${companyId}/qb/vendors/${vendorId}/dispatcher`, body);
const deleteVendorDispatcher = (companyId, vendorId) => apiV2.delete(`/company/${companyId}/qb/vendors/${vendorId}/dispatcher`);

const deleteCustomerMapping = ({ companyId, qbCustomerId }) => apiV2.delete(`/company/${companyId}/qb/customers/${qbCustomerId}`);
const deleteVendorMapping = ({ companyId, qbVendorId }) => apiV2.delete(`/company/${companyId}/qb/vendors/${qbVendorId}`);
const deleteVendorDiscountMapping = ({ companyId, qbVendorId, discountId }) => apiV2.delete(`/company/${companyId}/qb/vendors/${qbVendorId}/discount/${discountId}`);

const mapCustomerCompany = ({ companyId, realmId, ltnCompanyId, body }) => apiV2.delete(`/company/${companyId}/qb/${realmId}/customers/${ltnCompanyId}`, body);

/**
 *
 * Body: {
 * "invoiceNumber": "",
 * sendInvoiceNow: boolean,
 * loadId: "<load ID>",
 * "qbCustomerAccountId":
 * "<mapped account ID>"}
*/
const exportInvoice = ({ companyId, body }) => apiV2.post(`/company/${companyId}/qb/invoice`, body);
const exportBillableExpense = ({ companyId, body }) => apiV2.post(`/company/${companyId}/qb/billableExpense`, body);

export default {
  initiate,
  saveAuthentication,
  revokeAuthentication,
  refreshQuickbooksAccount,
  getAccounts,
  getCustomers,
  getVendors,
  exportInvoice,
  exportBillableExpense,
  getSalesTerms,
  getSalesItems,
  getTaxCodes,
  saveExportDefaults,
  updateVendorDispatcher,
  deleteVendorDispatcher,

  deleteCustomerMapping,
  deleteVendorMapping,
  deleteVendorDiscountMapping,
  mapCustomerCompany,
};



// WEBPACK FOOTER //
// ./src/api/quickBooks.js